import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { ShiftTeamTypeModel } from '@/libs/Api';
import { ShiftTeamTypesDataService } from '@/libs/shift-team-types/shift-team-types-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const shiftTeamTypesStore = registerCrudStore<ShiftTeamTypeModel, ShiftTeamTypeModel>(
    BusinessModule.ShiftTeamType,
    new ShiftTeamTypesDataService()
);


